import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card, Th, Td, Empty, fmtDate } from "./ui";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function Invoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/invoices").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const download = async (inv) => {
    try {
      const res = await api.get(`/admin/invoices/${inv.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${inv.invoice_number}.pdf`; a.click(); URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div>
      <PageHeader title="Facturen" subtitle="Automatisch gegenereerde PDF-facturen" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Factuurnr</Th><Th>Bedrag</Th><Th>Uitgegeven</Th><Th>Betaald</Th><Th>Actie</Th></tr></thead>
            <tbody>
              {rows.map((inv) => (
                <tr key={inv.id} className="border-b border-white/5" data-testid={`invoice-row-${inv.invoice_number}`}>
                  <Td className="font-medium text-sfc-orange">{inv.invoice_number}</Td>
                  <Td>€{inv.amount.toFixed(2)}</Td>
                  <Td className="text-white/50">{fmtDate(inv.issued_at)}</Td>
                  <Td className="text-white/50">{fmtDate(inv.paid_at)}</Td>
                  <Td><button onClick={() => download(inv)} className="flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs text-white/80 hover:bg-white/10"><Download size={13} /> PDF</button></Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Nog geen facturen" />}
        </div>
      </Card>
    </div>
  );
}
